/**
 * Restricts href values to safe internal/external URL forms.
 * Blocks protocol-relative URLs and unsupported schemes like javascript:.
 */
export function isAllowedHref(href: string): boolean {
  if (href.startsWith('//')) return false;
  return (
    href.startsWith('/') ||
    href.startsWith('http://') ||
    href.startsWith('https://') ||
    href.startsWith('#')
  );
}
